import React from 'react'
import PropTypes from 'prop-types';
import { Progress } from 'reactstrap';

export const Loading = (props) => {
    return (
        <div className={"app-loading " + (props.Show === true || props.Show === undefined ? "show" : "") }>
        <div className="wrapper-page">
                <div className="card">
                    <div className="card-body text-center">
                        <h4 className="card-title font-16 mt-0">{props.Title}</h4>
                        <p className="card-text">{props.Description}</p>
                        {props.Progress ? <Progress animated color="success" className="mydocuments-progressbar" value={props.Progress} /> :
                                                <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                    }

                    </div>
                </div>
        </div>
        </div>
    )
}
Loading.prototype={
    Show: PropTypes.bool,
    Title: PropTypes.string,
    Description: PropTypes.string,
}

Loading.defaultProps = {
    Title: "Checking Authorization",
    Description: "Checking user information and loading content, please wait..."
};